export default __webpack_public_path__ + "static/media/administrator.4bb1333a.png";